import { from, throwError, of } from "rxjs";
import { catchError } from "rxjs/operators";
import "@opentelemetry/api";
import "../otel/TraceProvider.js";
import { applyLocationAttrs, applyUserAttrs, applyHttpRequestAttrs, applyHttpResponseAttrs } from "../otel/OtelSpan.js";
import "react";
import "react-error-boundary";
import { mergeMap } from "../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
function fetchWithTracing(tracingService) {
  return function fetchFunction(url, request, user, parentSpan) {
    const method = request?.method ?? "GET";
    const tracer = tracingService.getTracer();
    const ctx = tracingService.setSpanOnContext(parentSpan);
    return tracer.startActiveSpan(`REST HTTP ${method}`, void 0, ctx, (span) => {
      applyLocationAttrs(span);
      applyUserAttrs(span, user);
      applyHttpRequestAttrs(span, url, method, "fetch");
      return from(fetch(url, request)).pipe(
        mergeMap((r) => {
          return from(r.json()).pipe(
            mergeMap((responseBody) => {
              let result;
              if (!r.ok) {
                const error = new FailedFetchError(r.status, responseBody?.traceId, r.statusText);
                result = throwError(() => error);
              } else {
                applyHttpResponseAttrs(span, r.status?.toString());
                tracingService.endSpanOk(span);
                result = of(responseBody);
              }
              return result;
            })
          );
        }),
        catchError((e) => {
          applyHttpResponseAttrs(span, e.status?.toString(), e.traceId, e.message);
          tracingService.endSpanFailed(span, e.message);
          return throwError(() => e);
        })
      );
    });
  };
}
class FailedFetchError extends Error {
  _status;
  _traceId;
  _message;
  constructor(status, traceId, message) {
    super();
    this._status = status;
    this._traceId = traceId;
    this._message = message;
  }
  get status() {
    return this._status;
  }
  get traceId() {
    return this._traceId;
  }
  get message() {
    return this._message;
  }
}
export {
  fetchWithTracing
};
//# sourceMappingURL=fetchProxy.js.map
